import imgixConfig from 'Config/imgix';

/**
 * The srcset and fallback src of a take over's background image. Also used by its skeleton
 * (Components/Skeleton/SkeletonTakeOver), so both request the same URLs.
 * @param  {String} bgImgSrc Absolute image URL
 * @return {Object} { srcSet, src }
 */
export default function backgroundSources(bgImgSrc) {
  const srcSet = `
  ${bgImgSrc}?${imgixConfig}&w=5000&h=400&fit=max 5000w,
  ${bgImgSrc}?${imgixConfig}&w=3640&h=291&fit=max 3640w,
  ${bgImgSrc}?${imgixConfig}&w=3100&h=248&fit=max 3100w,
  ${bgImgSrc}?${imgixConfig}&w=2560&h=205&fit=max 2560w,
  ${bgImgSrc}?${imgixConfig}&w=1920&h=154&fit=max 1920w,
  ${bgImgSrc}?${imgixConfig}&w=1440&h=115&fit=max 1440w,
  ${bgImgSrc}?${imgixConfig}&w=1080&h=86&fit=max 1080w,
  ${bgImgSrc}?${imgixConfig}&w=768&h=72&fit=max 768w`;

  return { srcSet, src: `${bgImgSrc}?${imgixConfig}&w=2560&h=205&fit=max` };
}
